import Vue from 'vue';
import Router from 'vue-router';

import SharedRoutes from '@/components/routes';
import AccountRoutes from '@/components/account/routes';
import ContactRoutes from '@/components/contact/routes';
import ClockRoutes from '@/components/clock/routes';
import CustomerRoutes from '@/components/customer/routes';
import EnquiryRoutes from '@/components/enquiry/routes';
import PlannerRoutes from '@/components/routeplan/routes';
import ContractRoutes from '@/components/contract/routes';
import SettingsRoutes from '@/components/settings/routes';
import JobRoutes from '@/components/job/routes';

Vue.use(Router);

var allRoutes = [];
allRoutes = allRoutes.concat(
    SharedRoutes, 
    AccountRoutes, 
    ContactRoutes, 
    ClockRoutes, 
    CustomerRoutes, 
    EnquiryRoutes,
    PlannerRoutes,
	ContractRoutes,
	SettingsRoutes,
	JobRoutes
);

const routes = allRoutes;

export default new Router({
    mode: 'history',
    routes : routes
});


// WEBPACK FOOTER //
// ./src/router/index.js